import { inject } from 'aurelia-framework';
import { Router } from 'aurelia-router';
import { AuthService } from '../../services/authService';
import { AccountAPI } from '../../services/accountAPI';
import { UserMessageService } from '../../services/userMessageService';

@inject(AuthService, Router, AccountAPI, UserMessageService)
export class Agreements {
    constructor(authService, router, api, userMessageService) {

        this.authService = authService;
        this.router = router;
        this.api = api;
        this.userMessageService = userMessageService;

        this.home_url_new = window.location.origin;
        this.home_url = window.home_url;
        this.privacy_url = this.home_url + '/privacy-policy';
        this.tos_url = this.home_url + '/terms-of-service';
        this.app_name = "Magnfi";
        if (window.whitelabel) {
            this.whitelabel = window.whitelabel;

            this.privacy_url = window.privacy_url;
            this.tos_url = window.tos_url;
            this.app_name = window.app_name;
        }

    }


    submit() {
        if (this.tosChecked && this.privacyChecked) {
            this.api.agreementsChecked(
                this.authService.getUser().token,
                () => { 
                    var user = this.authService.getUser();
                    user.agreements_checked = true;
                    this.authService.setUser(user);
                    this.router.navigate("home"); 
                },
                (error) => { this.userMessageService.setUserError('user', error); }
            );
        }
    }




}
